var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"lighting_container"}},[_c('div',{staticClass:"lighting_header"},[_c('p',[_vm._v("闪电发货")])]),_c('div',{staticClass:"jiange"}),_c('div',{staticClass:"light_details"},[_c('p',[_vm._v("心选App购买的产品，八号地后台会根据距离产品种类数量优先选择就近商店或库房配送；全国目前已有300多家线下门店，覆盖中国大多地级市。八号地愿为消费者第一时间送达我们的好产品！")])])])
}]

export { render, staticRenderFns }